import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	shareTriggerButtonText: {
		id: 'jira.share-dialog.trigger-button-text',
		defaultMessage: 'Share',
		description: 'Default text for the share dialog trigger button',
	},
	shareTriggerButtonTooltipText: {
		id: 'jira.share-dialog.trigger-button-tooltip-text',
		defaultMessage: 'Share',
		description: 'Default text for tooltip on the icon-only share dialog trigger button',
	},
	sharePopupLabel: {
		id: 'jira.share-dialog.popup-label',
		defaultMessage: 'Share',
		description: 'Label of the popup that contains share menu used by assistive technologies',
	},
});
